import axios from 'axios';
import environment from '../config/environment';
import MockAdapter from 'axios-mock-adapter';
import networkErrorInterceptor from './interceptors/network-error-interceptor';
import { authInterceptor } from './interceptors/auth-interceptor';

export const omniChannelApi = axios.create({
  baseURL: environment['OMINICHANNEL_API_BASE_URL'],
});

export const pointcastApi = axios.create({
  baseURL: environment['POINTCAST_API_BASE_URL'],
});

export const esCdn = axios.create({
  baseURL: environment['ES_CDN_BASE_URL'],
});

const api = axios.create({
  baseURL: environment['ES_API_BASE_URL'],
});

authInterceptor(api);
authInterceptor(pointcastApi);

networkErrorInterceptor(api);

export const setupMockInterceptor = () => {
  const mock = new MockAdapter(api);
  mock.onAny().passThrough();
};

export default api;
